import { render, staticRenderFns } from "./ParentFeedback.vue?vue&type=template&id=ec80dd6c&scoped=true"
import script from "./ParentFeedback.vue?vue&type=script&lang=js"
export * from "./ParentFeedback.vue?vue&type=script&lang=js"
import style0 from "./ParentFeedback.vue?vue&type=style&index=0&id=ec80dd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec80dd6c",
  null
  
)

export default component.exports